import * as types from './types';

export const getAllocations = (userId, page = 1) => ({
  type: types.GET_ALLOCATIONS,
  payload: { userId, page }
});

export const getAllocationsSucceeded = (response) => ({
  type: types.GET_ALLOCATIONS_SUCCEEDED,
  payload: { response }
});

export const getAllocationsFailed = (page) => ({
  type: types.GET_ALLOCATIONS_FAILED,
  payload: { page }
});

export const getBypassedAllocations = (userId, page = 1) => ({
  type: types.GET_BYPASSED_ALLOCATIONS,
  payload: { userId, page }
});

export const getBypassedAllocationsSucceeded = (response) => ({
  type: types.GET_BYPASSED_ALLOCATIONS_SUCCEEDED,
  payload: { response }
});

export const getBypassedAllocationsFailed = (page) => ({
  type: types.GET_BYPASSED_ALLOCATIONS_FAILED,
  payload: { page }
});

export const getQuickAllocations = (userId, page = 1) => ({
  type: types.GET_QUICK_ALLOCATIONS,
  payload: { userId, page }
});

export const getQuickAllocationsSucceeded = (response) => ({
  type: types.GET_QUICK_ALLOCATIONS_SUCCEEDED,
  payload: { response }
});

export const getQuickAllocationsFailed = (page) => ({
  type: types.GET_QUICK_ALLOCATIONS_FAILED,
  payload: { page }
});

export const setPurchase = (purchase) => ({
  type: types.SET_PURCHASE,
  payload: { purchase }
});

export const checkRenewal = (userId) => ({
  type: types.CHECK_RENEWAL,
  payload: { userId }
});

export const clearAllocations = () => ({
  type: types.CLEAR_ALLOCATIONS,
});
